import { Datatable, SearchHeader, SubHeader } from "../../../../common";
import { deleteOption, getOptions } from "../../../../../api";
import { useLanguage } from "../../../../../context";
import { useNavigate } from "react-router-dom";
import { Icon } from "../../../../Libraries";
import { useEffect, useState } from "react";

const VariantOptionList = () => {
    const { I18n } = useLanguage();
    let navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [pagination, setPagination] = useState({
        resultsPerPage: 10,
        totalCount: 0,
        page: 1,
    });

    useEffect(() => {
        handleVariantOptions();
    }, []);

    const onDelete = async (id) => {
        try {
            const data = await deleteOption(id, { archive: true });
            if (data.success) handleVariantOptions();
        } catch (err) { }
    };

    const handleVariantOptions = async (reqPage = 1, filters = undefined) => {
        try {
            setLoading(true);

            let params = {
                resultsPerPage: pagination.resultsPerPage,
                page: reqPage
            };

            if (filters) params = { ...params, ...filters };

            const { data } = await getOptions(params);
            const { resultsPerPage, totalCount, options, page } = data || {};

            setPagination({ resultsPerPage, totalCount, page });
            setList(options.map(option => {
                return {
                    values: option?.values?.toString() || '',
                    nameLocal: option.nameLocal || '',
                    createdAt: option.createdAt,
                    name: option.name || '',
                    type: option.type,
                    _id: option._id,
                }
            }));

        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const onPageChange = (page) => {
        if (page == pagination.current || loading) return;
        handleVariantOptions(page);
    };

    const addOption = () => navigate('/variant-option/create');

    return (
        <div className="page-wrapper">
            <div className="content">
                <SubHeader
                    data={{
                        subTitle: 'manage_ur_variant_options',
                        title: 'variant_options_list',
                        overlays: [
                            {
                                svg: 'assets/img/icons/pdf.svg',
                                tipType: I18n.pdf
                            },
                            {
                                svg: 'assets/img/icons/excel.svg',
                                tipType: I18n.excel
                            },
                            {
                                onClick: handleVariantOptions,
                                Icon: Icon['referesh'],
                                tipType: I18n.refresh,
                                disabled: loading
                            }
                        ],
                        actions: [
                            {
                                className: 'btn btn-added',
                                title: 'add_new_option',
                                action: addOption,
                                icon: 'plus',

                            }
                        ],
                    }}
                />

                <div className="card table-list-card">
                    <div className="card-body">
                        <SearchHeader applyFilter={handleVariantOptions} />

                        <div className="table-responsive">
                            <Datatable
                                onPageChange={onPageChange}
                                pagination={pagination}
                                type="variant-option"
                                onDelete={onDelete}
                                loading={loading}
                                dataSource={list}
                                noOfColumns={5}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VariantOptionList;